export const CUSTOMER_TYPES = [
  'Private University',
  'Autonomous College',
  'Regular College',
  'Open University',
  'Other Educational Institute',
  'Franchise',
  'Corporate',
  'Master Franchise',
  'Direct Student',
  'Other'
];

export const LEAD_STAGES = [
  'New',
  'Contacted',
  'Interested',
  'Proposal Sent',
  'Negotiation',
  'Partnership Closed',
  'Lost'
];

export const PRIORITIES = ['High', 'Medium', 'Low'];

export const LEAD_SOURCES = [
  'cold_call',
  'referral',
  'LinkedIn',
  'email_campaign',
  'walk_in',
  'web_form',
  'RCM'
];

export const FOLLOWUP_TYPES = ['Call', 'Email', 'WhatsApp', 'Site Visit', 'Other'];

export const FOLLOWUP_OUTCOMES = ['Positive', 'Neutral', 'Negative', 'No Response', 'Rescheduled', 'Pending'];

export const ROLES = ['super_admin', 'admin', 'internal_team'];
export const SUB_ROLES = ['MD', 'SVP', 'RCM', 'Manager', 'Intern', 'Support Member'];

export const STAGE_COLORS = {
  'New': { bg: '#e0e7ff', text: '#4338ca' },
  'Contacted': { bg: '#fef3c7', text: '#d97706' },
  'Interested': { bg: '#d1fae5', text: '#059669' },
  'Proposal Sent': { bg: '#dbeafe', text: '#2563eb' },
  'Negotiation': { bg: '#ede9fe', text: '#7c3aed' },
  'Partnership Closed': { bg: '#dcfce7', text: '#16a34a' },
  'Lost': { bg: '#fee2e2', text: '#dc2626' }
};

export const PRIORITY_COLORS = {
  'High': { bg: '#fee2e2', text: '#dc2626' },
  'Medium': { bg: '#fef3c7', text: '#d97706' },
  'Low': { bg: '#f0fdf4', text: '#16a34a' }
};

export const INDIA_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh',
  'Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab',
  'Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh',
  'Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh','Puducherry'
];

export const PROGRAM_FEE = {
  base: 126000,
  gst_rate: 0.18,
  get gst() { return this.base * this.gst_rate; },
  get total() { return this.base + (this.base * this.gst_rate); },
  commission: 12600
};
